import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  hubFilter,
  date,
  setDate,
  setHubFilter,
  workingHoursFilter,
  setWorkingHoursFilter,
  applyFilters,
  removeFilters,
  allHubs,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="hubFilter">
            <Form.Label>
              <b>Hubs</b>
            </Form.Label>

            <Form.Control
              as="select"
              value={hubFilter || ""}
              onChange={(e) => setHubFilter(e.target.value)}
            >
              <option value="">All Hubs</option>
              {allHubs &&
                allHubs
                  .filter(
                    (hub) => hub.status?.trim().toLowerCase() === "active",
                  )
                  .map((hub, index) => (
                    <option key={index} value={hub._id}>
                      {hub.name}
                    </option>
                  ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="dateFilter">
            <Form.Label>
              <b>Date</b>
            </Form.Label>
            <Form.Control
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              max={new Date().toISOString().split("T")[0]}
            />
          </Form.Group>
          <Form.Group controlId="workingHoursFilter" className="mt-3">
            <Form.Label>
              <b>Working Hours</b>
            </Form.Label>
            <Form.Control
              as="select"
              value={workingHoursFilter || ""}
              onChange={(e) => setWorkingHoursFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="0-4">0 - 4 hrs</option>
              <option value="4-8">4 - 8 hrs</option>
              <option value="8-12">8 - 12 hrs</option>
              <option value="12+">Above 12 hrs</option>
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
